/**
 * A bet or selection whose result was voided - cancelled, pushed, or manually cancelled - all of
 * which surface to the user as a refund. `MANUALLY_CANCELLED` is kept distinct on the wire
 * (esportspools SBK-2480), so every void check must include it or the bet falls into Open.
 */
export const isVoidedResult = (result: string | undefined): boolean =>
    result === 'CANCELLED' || result === 'PUSHED' || result === 'MANUALLY_CANCELLED';
